// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";

import { isCalculatedFilterDetail } from "../apiCalculatedFiltersAppGroupId/validators";

export const isGetApiCalculatedFiltersIdAppGroupIdResult = objectOf({
  calculated_filter: isCalculatedFilterDetail,
});

export const isPutApiCalculatedFiltersIdAppGroupIdResult = objectOf({
  calculated_filter: isCalculatedFilterDetail,
});
